import { render } from "./MainSliderComponent.vue?vue&type=template&id=5dad02c9"
import script from "./MainSliderComponent.vue?vue&type=script&lang=js"
export * from "./MainSliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__